import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgModule } from '@ui/svg';
import { TranslateModule } from '@ngx-translate/core';
import { ServiceStatusIconComponent } from '@app/services/components/service-status-icon/service-status-icon.component';
import { TooltipModule } from '@smooved/ui';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { StatusBadgeStatus } from '@ui-v2/atoms/status-badge/status-badge.constants';

@Component({
    selector: 'app-water-detail-form-element',
    standalone: true,
    imports: [FormsModule, SvgModule, TranslateModule, ReactiveFormsModule, ServiceStatusIconComponent, TooltipModule, InlineSVGModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="u-background-gray-ultralight u-border-radius-large u-padding">
            <div class="u-flex-row u-flex-align-items-center u-margin-bottom">
                @if (showServiceStatusIcon) {
                    <app-service-status-icon class="pr-2" [status]="serviceStatusIcon"></app-service-status-icon>
                }
                <h3 class="u-font-weight-semi-bold u-color-gray-ultradark u-font-size-20">
                    {{ title | translate }}
                </h3>
                @if (tooltip) {
                    <div
                        class="__tooltip u-color-muted u-margin-left-half"
                        appTooltip
                        [template]="nrnTooltip"
                        inlineSVG="https://assets.smooved.be/icons/v2/20/question.svg"
                    ></div>
                }
            </div>
            <ng-content></ng-content>
        </div>

        <ng-template #nrnTooltip>
            {{ tooltip | translate }}
        </ng-template>
    `,
})
export class WaterDetailFormElementComponent {
    @Input() public showServiceStatusIcon: boolean = false;
    @Input() public serviceStatusIcon: StatusBadgeStatus;
    @Input() public title: string;
    @Input() public tooltip: string;
}
